export default "__VITE_ASSET__D9eqx490__";